import { TradePathData } from "@cede/types";

export const getTradePathLabel = (tradePath: TradePathData[]) => {
  return tradePath.reduce((acc, path) => acc + ` → ${path.to}`, tradePath[0]?.from || "");
};
